/**
 * Canonical AX1 avatar identity treatment.
 *
 * Identity colours stay within the governed primary ramp so they remain calm,
 * brand-aligned, and tenant-aware in the React UI. The fixed hex values are
 * used only by self-contained demo SVGs, which cannot inherit runtime tokens.
 */
export const AVATAR_IDENTITY_TONES = [
  { className: 'bg-primary-600 text-action-primary', demoHex: '#2455ab' },
  { className: 'bg-primary-700 text-action-primary', demoHex: '#1d478f' },
  { className: 'bg-primary-800 text-action-primary', demoHex: '#14396f' },
  { className: 'bg-primary-900 text-action-primary', demoHex: '#0b2a54' },
] as const;

function avatarHash(value: string): number {
  let hash = 0;
  for (const character of value.trim().toLowerCase()) {
    hash = ((hash * 31) + character.codePointAt(0)!) >>> 0;
  }
  return hash;
}

export function getAvatarInitials(name: string): string {
  const normalized = (name || '').trim().replace(/\s+/g, ' ');
  if (!normalized) return '?';

  const words = normalized.split(' ');
  const first = Array.from(words[0] || '')[0] || '';
  const last = words.length > 1
    ? Array.from(words[words.length - 1] || '')[0] || ''
    : Array.from(words[0] || '')[1] || '';

  return `${first}${last}`.toUpperCase() || '?';
}

export function getAvatarIdentityTone(seed: string) {
  return AVATAR_IDENTITY_TONES[avatarHash(seed || 'ax1') % AVATAR_IDENTITY_TONES.length];
}
